const useMakeSkyflowStyles = (styles = {}) => {
    return function useStyles() {
        const classes = styles;
        return classes;
    };
};
export default useMakeSkyflowStyles;
//# sourceMappingURL=index.js.map